import { render } from "./ShopProducts.vue?vue&type=template&id=299f41dc&scoped=true&ts=true"
import script from "./ShopProducts.vue?vue&type=script&lang=ts"
export * from "./ShopProducts.vue?vue&type=script&lang=ts"

import "./ShopProducts.vue?vue&type=style&index=0&id=299f41dc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299f41dc"]])

export default __exports__